// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1iqCr","unreadBadge":"styles_unreadBadge__RKvjC","modalContent":"styles_modalContent__1TXBL","modal":"styles_modal__o5lfh"};